import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface LoginResponse {
  status: number;
  data: {
    memberId: string;
    name: string;
    nickname: string;
    profileImagePath: string;
    accessToken: string;
    refreshToken: string;
    tokenExp: number;
  };
}

const Login = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated) {
      navigate('/wallets');
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          password: password
        })
      });

      const data: LoginResponse = await response.json();

      if (data.status === 200) {
        // 토큰들을 로컬스토리지에 저장
        localStorage.setItem('accessToken', data.data.accessToken);
        localStorage.setItem('refreshToken', data.data.refreshToken);
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('memberId', data.data.memberId);
        localStorage.setItem('name', data.data.name);
        localStorage.setItem('nickname', data.data.nickname);
        localStorage.setItem('profileImagePath', data.data.profileImagePath);
        localStorage.setItem('tokenExp', data.data.tokenExp.toString());
        
        navigate('/wallets');
      } else {
        alert('로그인에 실패했습니다.');
      }
    } catch (error) {
      console.error('로그인 오류:', error);
      alert('로그인 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h1 className="login-title">TRIX Wallet Monitoring</h1>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          value={id}
          onChange={(e) => setId(e.target.value)}
          placeholder="아이디"
          disabled={isLoading}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="비밀번호"
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? '로그인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
};

export default Login;